import { GridColDef } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Switch, Tooltip } from "@mui/material";
import ActionButton from "../client-config/action-button";
import { FilterOptionDetail } from "./types";

export const getColumns = ({
  onEdit,
  onDelete,
  onToggleEnabled,
}: {
  onEdit: (row: FilterOptionDetail) => void;
  onDelete: (row: FilterOptionDetail) => void;
  onToggleEnabled: (row: FilterOptionDetail) => void;
}): GridColDef[] => [
  { field: "code", headerName: "Code", flex: 1 },
  { field: "description", headerName: "Description", flex: 1 },
  {
    field: "isDefaultSelected",
    headerName: "Default Selected",
    type: "boolean",
    maxWidth: 150,
    flex: 1,
  },
  {
    field: "isSynthetic",
    headerName: "Synthetic",
    type: "boolean",
    maxWidth: 110,
    flex: 1,
  },
  { field: "sortOrder", headerName: "Sort Order", maxWidth: 110 },
  {
    field: "isEnabled",
    headerName: "Enabled",
    maxWidth: 100,
    align: "center",
    headerAlign: "center",
    renderCell: (params) => (
      <Tooltip
        title={params.row.isEnabled ? "Click to disable" : "Click to enable"}
        placement="top"
      >
        <Switch
          checked={params.row.isEnabled}
          onChange={(e) => {
            e.stopPropagation();
            onToggleEnabled(params.row);
          }}
          onClick={(e) => e.stopPropagation()}
          color="success"
          size="small"
        />
      </Tooltip>
    ),
  },
  {
    field: "actions",
    type: "actions",
    flex: 1,
    align: "right",
    maxWidth: 150,
    getActions: ({ row }: { row: FilterOptionDetail }) => [
      <ActionButton
        key="edit"
        onClick={(e) => {
          e.stopPropagation();
          onEdit(row);
        }}
      >
        <EditIcon fontSize="small" />
      </ActionButton>,
      <ActionButton
        key="delete"
        onClick={(e) => {
          e.stopPropagation();
          onDelete(row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </ActionButton>,
    ],
  },
];

export default getColumns;
